<template>
  <div class="location-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Name</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(location, i) in locations" :key="i">
					<td class="name">{{ location.name }}</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', location)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', location)" v-if="i > 0">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="locations.length === 0">
					<td colspan="6">No locations found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['locations']
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Locations/List.vue